import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=d4864c34&scoped=true"
import script from "./VersionUpdate.vue?vue&type=script&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=d4864c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4864c34",
  null
  
)

export default component.exports